import { i18n } from '../../../i18n'
import exporterRenders from '../../../modules/shared/exporter/exporterRenders'

export default [
  {
    name: 'id',
    label: i18n('entities.city.fields.id'),
  },
  {
    name: 'name',
    label: i18n('entities.city.fields.name'),
  },
  {
    name: 'country',
    label: i18n('entities.city.fields.country'),
    render: exporterRenders.relationToOne(),
  },
  {
    name: 'createdAt',
    label: i18n('entities.city.fields.createdAt'),
    render: exporterRenders.datetime(),
  },
  {
    name: 'updatedAt',
    label: i18n('entities.city.fields.updatedAt'),
    render: exporterRenders.datetime(),
  },
]
